//import { JsonHubProtocol, HttpTransportType, HubConnectionBuilder, HubConnectionState, LogLevel } from '@aspnet/signalr'; // version 1.0.4
import { JsonHubProtocol, HttpTransportType, HubConnectionBuilder, HubConnectionState, LogLevel } from '@microsoft/signalr'; // version 3.1.0
import { showMessage } from '../actions/uiActions'
import { showPresentationsProgress, getPresentations, clearPresentationProgress, alertPresentationIsReady } from '../actions/presentationActions'
import { resetJobs, sendDatabaseJobProgress } from '../actions/dbFunctionsActions'

const startSignalRConnection = connection => connection.start()
    .then(() => console.info('SignalR Connected'))
    .catch(err => console.error('SignalR Connection Error: ', err));

const connectionHub = `${process.env.REACT_APP_WEBSOCKET_URL}`;

const protocol = new JsonHubProtocol();
//  skipNegotiation required for load balancer, otherwise negotation connects to one server and then another and the connection is missing
const transport = HttpTransportType.WebSockets // | HttpTransportType.ServerSentEvents |HttpTransportType.LongPolling;

let options = {
    transport,
    logMessageContent: true,
    logger: LogLevel.Trace,
    accessTokenFactory: () => { return localStorage.getItem("jwt_token") }
};

// Using Azure SignalR requires the [skipNegotiation] set to false, but other SignalR technologies (like Reddis) need this set to true
if (process.env.REACT_APP_AZURE_SIGNALR === "true") {
    options["skipNegotiation"] = false;
} else {
    options["skipNegotiation"] = true;
}

const connection = new HubConnectionBuilder()
    .withUrl(connectionHub, options)
    .withAutomaticReconnect([0, 2000, 6000, 10000])
    .withHubProtocol(protocol)
    .build();

export const signalRMiddleware = ({ getState }) => next => async (action) => {
    switch (action.type) {
        case 'LOGIN_USER':
            startSignalRConnection(connection)
            break
        case 'LOGOUT_USER':
            connection.stop()
            break
        default:
            break
    }
    return next(action);
};

export const signalRRegisterCommands = (store) => {

    connection.serverTimeoutInMilliseconds = 1000 * 60 * 10; // 1 second * 60 * 10 = 10 minutes.

    connection.onreconnecting((error) => {
        console.assert(connection.state === HubConnectionState.Reconnecting);        
        if (error) {
            console.log(`SignalR connection lost due to error "${error}". Reconnecting.`);
        } else {
            console.log(`SignalR reconnecting.`);
        }
    });

    connection.onclose((error) => {
        console.assert(connection.state === HubConnectionState.Disconnected);
        if (error) {
            console.log(`SignalR connection closed due to error "${error}". Try refreshing this page to restart the connection.`);
        } else {
            console.log(`SignalR connection closed.`);
        }
    });
    
    connection.on('SendMessage', (presentationID, message) => {
        return store.dispatch(showMessage(message, true))
    });

    connection.on('SendProgress', (presentationID, message) => {
        store.dispatch(showPresentationsProgress(presentationID, message))
        return store.dispatch(getPresentations(false))
    })

    connection.on("SendFinishedProgress", (presentationID, message) => {
        store.dispatch(clearPresentationProgress(presentationID))
        store.dispatch(getPresentations(false))
        return store.dispatch(alertPresentationIsReady(presentationID))
    })

    connection.on("SendFailed", (presentationID, message) => {
        store.dispatch(clearPresentationProgress(presentationID))
        store.dispatch(getPresentations(false))
        return store.dispatch(showMessage(`Error occured during ${presentationID} refresh. ${message}`, false))
    })

    connection.on("SendDatabaseJobProgress", (jobId, partsCompleted, totalParts) => {
        return store.dispatch(sendDatabaseJobProgress(jobId, partsCompleted, totalParts))
    })

    connection.on("SendFinishedDatabaseJob", (jobId) => {
        return store.dispatch(resetJobs())
    })
}